import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface FeatureConfigFooterProps {
  onCancel: () => void;
  onApply: () => void | Promise<void>;
  isLoading?: boolean;
}

export const FeatureConfigFooter: React.FC<FeatureConfigFooterProps> = ({
  onCancel,
  onApply,
  isLoading = false
}) => {
  useLanguage();
  const [internalLoading, setInternalLoading] = React.useState(false);

  const handleApply = async () => {
    if (internalLoading || isLoading) return;

    setInternalLoading(true);
    try {
      await onApply();
    } finally {
      setInternalLoading(false);
    }
  };

  const isButtonLoading = internalLoading || isLoading;

  return (
    <div className="border-t border-[#E5E7EB] bg-[#F7F9FC]/85 backdrop-blur-sm p-6 sticky bottom-0">
      <div className="flex items-center justify-end gap-3">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isButtonLoading}
          className="hover:bg-[background] hover:text-[black]"
        >
          {translateInterfaceText("Voltar")}</Button>

        <Button
          onClick={handleApply}
          disabled={isButtonLoading}
        >
          {isButtonLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              {translateInterfaceText("Salvando...")}</>
          ) : (
            translateInterfaceText("Aplicar")
          )}
        </Button>
      </div>
    </div>
  );
};